// studio 로 가는 1회용 코드 이동(K-17 — 토큰 쿼리 주소 대체). 지원 탭이면 서버가 같은 사람으로 studio 지원 세션을 새로 열어 지원 진입 코드를 줌(D1 11-01).
// admin-hospital src/services/handoff.service.js 와 같은 내용(studio 주소 설정 env 가 이 앱엔 없어 API 주소로 가림).
import apiInstance from "@/axios";
import { handoffUrl, studioBase } from "@/utils/handoff";


/**
 * 새 탭으로 studio 의 to 경로를 엶. 팝업 차단을 피하려고 빈 탭을 먼저 열고 코드를 받은 뒤 주소를 채움.
 * @returns {Promise<'opened'>}
 */
export async function openStudio(to = "/") {
  const win = window.open("", "_blank");
  if (win) win.opener = null;
  try {
    const { data } = await apiInstance.post("/auth/handoff", { app: "studio" });
    const url = handoffUrl(studioBase(process.env.VUE_APP_STUDIO_SERVER, process.env.VUE_APP_SERVERURL), data.code, to, data.support === true);
    if (win) win.location.href = url;
    else window.open(url, "_blank", "noopener");
    return "opened";
  } catch (error) {
    if (win) win.close();
    throw error;
  }
}
